goog.provide("shadow.js.shim.module$src$svg$wpp$files$add_document_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$files$add_document_svg");
shadow.js.shim.module$src$svg$wpp$files$add_document_svg = shadow.js.nativeProvides["src/svg/wpp/files/add-document.svg"] = shadow$bridge("src/svg/wpp/files/add-document.svg");
module$shadow_js_shim_module$src$svg$wpp$files$add_document_svg.default = shadow.js.shim.module$src$svg$wpp$files$add_document_svg;
